import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const MASTERY_COLORS = {
  mastered: '#10B981',
  developing: '#3B82F6',
  emerging: '#F59E0B',
  not_demonstrated: '#EF4444',
};

const MASTERY_ORDER = ['not_demonstrated', 'emerging', 'developing', 'mastered'];

export default function SkillMasteryChart({ data, height = 300 }) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 bg-gray-50 rounded-lg">
        <p className="text-gray-500">No skill data available</p>
      </div>
    );
  }

  // Sort skills by mastery level (worst to best)
  const sortedData = [...data].sort((a, b) => {
    const aIndex = MASTERY_ORDER.indexOf(a.mastery_level);
    const bIndex = MASTERY_ORDER.indexOf(b.mastery_level);
    return aIndex - bIndex;
  });

  // Limit to top 15 skills for readability
  const chartData = sortedData.slice(0, 15).map((skill) => ({
    name: skill.skill_name.length > 25 ? skill.skill_name.substring(0, 25) + '...' : skill.skill_name,
    fullName: skill.skill_name,
    percentage: Math.round(skill.percentage),
    mastery: skill.mastery_level,
    code: skill.skill_code,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white shadow-lg rounded-lg p-3 border border-gray-200 max-w-xs">
          <p className="font-medium text-gray-900">{data.fullName}</p>
          <p className="text-xs text-gray-500">{data.code}</p>
          <p className="text-lg font-bold" style={{ color: MASTERY_COLORS[data.mastery] }}>
            {data.percentage}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 10, right: 30, left: 100, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" horizontal={true} vertical={false} />
        <XAxis
          type="number"
          domain={[0, 100]}
          tick={{ fontSize: 12, fill: '#6B7280' }}
          tickFormatter={(value) => `${value}%`}
        />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 11, fill: '#6B7280' }}
          width={100}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="percentage" radius={[0, 4, 4, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={MASTERY_COLORS[entry.mastery]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
